import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/forgot-password', { email });
      setMessage({ type: 'success', text: response.data.message });
      setEmailSent(true);
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to send password reset email. Please try again.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-card">
        <div className="forgot-password-icon">🔑</div>
        <h2>Forgot Your Password?</h2>
        
        {!emailSent ? (
          <>
            <p className="forgot-password-description">
              No worries! Enter your email address and we'll send you a link to reset your password.
            </p>

            {message.text && (
              <div className={`message ${message.type}`}>
                {message.text}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  disabled={loading}
                  className="input-field"
                />
              </div>

              <button
                type="submit"
                className="btn-primary"
                disabled={loading}
                style={{ width: '100%', marginTop: '10px' }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <div className="forgot-password-links">
              <Link to="/login" className="back-link">
                ← Back to Login
              </Link>
              <Link to="/register" className="register-link">
                Don't have an account? Register
              </Link>
            </div>
          </>
        ) : (
          <>
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h3>Email Sent!</h3>
              <p>{message.text}</p>
              <p className="help-text">
                Please check your email inbox (and spam folder) for the password reset link.
                The link will expire in 30 minutes.
              </p>
            </div>

            <div className="forgot-password-links" style={{ marginTop: '20px' }}>
              <Link to="/login" className="btn-primary" style={{ width: '100%', textAlign: 'center' }}>
                Return to Login
              </Link>
              <button
                onClick={() => {
                  setEmailSent(false);
                  setEmail('');
                  setMessage({ type: '', text: '' });
                }}
                className="back-link"
                style={{ marginTop: '10px', background: 'none', border: 'none', cursor: 'pointer' }}
              >
                Send another email
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
